import { call, put, takeLatest } from "redux-saga/effects";
import { settingServices } from "../../services";
import * as actionTypes from "../actionTypes";
import * as actions from "../actions";

function* getOrderSettingsData() {
  const res = yield call(settingServices.getOrderSettings);
  if (res.status && res.data) {
    const data = res.data;
    console.log("iiiiii", data);
    yield put(actions.saveOrderSettings(data));
  }
}

function* postOrderSettings(action) {
  const res = yield call(settingServices.postOrderSettings, action.payload);
  if (res?.status && res?.data) {
    yield put(actions.showNotificationWithTimeout(res.message, "success"));
  } else {
    yield put(actions.showNotificationWithTimeout(res.message, "error"));
  }
}

function* getOrderTransferData(action) {
  const res = yield call(settingServices.getOrderTransferData);
  console.log("getOrderTransferData", res);
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.saveOrderTransferData(data));
  }
}

function* getSecondAccounts(action) {
  console.log(action.payload);
  const res = yield call(settingServices.getSecondAccounts, action.payload);
  console.log(res, "getSecondAccounts");
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.saveOrderTransferSecondaryAccounts(data));
  }
}

function* addTransferAccount(action) {
  const res = yield call(settingServices.addTransferAccount, action.payload);
  console.log(res);
  if (res?.status) {
    yield put(actions.getOrderTransferData());
  }
  console.log(res, "addTransferAccount");
}

function* getTransferAccountEditDetails(action) {
  console.log("getTransferAccountEditDetails", action.payload);
  const res = yield call(
    settingServices.getTransferAccountEditDetails,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.saveTransferAccountEditDetails(data));
  }
}
function* updateTransferAccountStatus(action) {
  console.log("updateTransferAccountStatus", action.payload);
  const res = yield call(
    settingServices.updateTransferAccountStatus,
    action.payload
  );
  if (res?.status) {
    yield put(actions.getOrderTransferData());
  }
}

function* editTransferAccount(action) {
  const res = yield call(settingServices.editTransferAccount, action.payload);
  if (res?.status) {
    yield put(actions.getOrderTransferData());
  }
}

function* postOrderTransferData(action) {
  const res = yield call(settingServices.postOrderTransferData, action.payload);

  if (res?.status && res?.data) {
    yield put(actions.showNotificationWithTimeout(res.message, "success"));
  } else {
    yield put(actions.showNotificationWithTimeout(res.message, "error"));
  }
}

function* orderSettingSaga() {
  yield takeLatest(actionTypes.GET_ORDER_SETTINGS, getOrderSettingsData);
  yield takeLatest(actionTypes.POST_ORDER_SETTINGS, postOrderSettings);
  yield takeLatest(actionTypes.GET_ORDER_TRANSFER_DATA, getOrderTransferData);
  yield takeLatest(actionTypes.POST_ORDER_TRANSFER_DATA, postOrderTransferData);
  yield takeLatest(actionTypes.GET_SECOND_ACCOUNTS, getSecondAccounts);
  yield takeLatest(actionTypes.ADD_TRANSFER_ACCOUNT, addTransferAccount);
  yield takeLatest(actionTypes.EDIT_TRANSFER_ACCOUNT, editTransferAccount);
  yield takeLatest(
    actionTypes.UPDATE_TRANSFER_ACCOUNT_STATUS,
    updateTransferAccountStatus
  );
  yield takeLatest(
    actionTypes.GET_TRANSFER_ACCOUNT_EDIT_DETAILS,
    getTransferAccountEditDetails
  );
  // yield takeLatest(
  //   actionTypes.UPDATE_TRANSFER_ACCOUNT_STATUS,
  //   updateTransferAccountStatus
  // );
}

export default orderSettingSaga;
